import {ajaxDelete, ajaxGet, ajaxPost, ajaxPost1, ajaxPut, uploadImg,download,ajaxDelete1} from './request';

// 商机管理（APN Partner Central）
export const apnOverview = params => ajaxGet({url: `opportunity/overview/`, params})
export const apnTree = params => ajaxGet({url: `opportunity/tree/`, params})
export const apnList = params => ajaxGet({url: `opportunity/list/`, params})
export const apnDetail = params => ajaxGet({url: `opportunity/detail/`, params})
export const apnInvitations = params => ajaxGet({url: `opportunity/invitations/`, params})
export const apnSync = params => ajaxPost({url: `opportunity/sync/`, params})
export const apnCreate = params => ajaxPost({url: `opportunity/create/`, params})
export const apnUpdateStage = params => ajaxPost({url: `opportunity/stage/`, params})
export const apnInvitationAction = params => ajaxPost({url: `opportunity/invitation/action/`, params})

// Dashboard

export const getSummaryData = params => ajaxGet({url: `stat/summary/`, params})
export const getSummaryTop10 = params => ajaxGet({url: `stat/summary/top10`, params})
export const getSummaryLinkData = params => ajaxGet({url: `stat/summary/linkCosts/`, params})
export const getSummaryProductData = params => ajaxGet({url: `stat/summary/productCosts/`, params})
export const getSummaryTop10Data = params => ajaxGet({url: `stat/summary/top10Details/`, params})
export const getEC2Data = params => ajaxGet({url: `stat/ec2/`, params})
export const getEC2Details = params => ajaxGet({url: `stat/ec2/details`, params})
export const getRDSData = params => ajaxGet({url: `stat/rds/`, params})
export const getRDSDetails = params => ajaxGet({url: `stat/rds/details`, params})
export const getRISPData = params => ajaxGet({url: `stat/risp/`, params})
export const getNetworkData = params => ajaxGet({url: `stat/network/`, params})
export const getNetworkDetails = params => ajaxGet({url: `stat/networkDetails/`, params})



//payer账号管理
// 获取列表（包含完整信息，仅管理员可获取敏感信息）
export const getPayerList = params => ajaxGet({url: `payer/`, params})
// 获取基础信息列表（不包含敏感凭证，用于下拉选择等场景）
export const getPayerBasicList = params => ajaxGet({url: `payer/basic/`, params})
// payer账号新增
export const newPayer = params => ajaxPost({url: `payer/`, params})
// payer账号删除
export const deleterPayer = params => ajaxDelete({url: `payer/`, params})
// payer账号修改
export const editPayer = params => ajaxPut({url: `payer/`, params})

// 合作伙伴管理
export const getAgentList = params => ajaxGet({url: `agent/`, params})
// 合作伙伴新增
export const newAgent = params => ajaxPost({url: `agent/`, params})
// 合作伙伴删除
export const deleterAgent = params => ajaxDelete({url: `agent/`, params})
// 合作伙伴修改
export const editAgent = params => ajaxPut({url: `agent/`, params})
// 合作伙伴 CUR API Key 管理
export const getAgentApiKey = agentId => ajaxGet({url: `agent/${agentId}/api-key/`})
export const createAgentApiKey = (agentId, params = {}) => ajaxPost({url: `agent/${agentId}/api-key/`, params})
export const deleteAgentApiKey = agentId => ajaxDelete1({url: `agent/${agentId}/api-key/`})
// 获取未分配合作伙伴的payer list
export const getUnassignedPayerList = params => ajaxGet({url: `payer/unassigned/`, params})

// Linker管理
export const getLinkerList = params => ajaxGet({url: `linker/`, params})
export const getBtLinkTree = params => ajaxGet({url: `linker/bt_tree/`, params}) // BT层级：佳杰PMA→二代PMA→CMA→link
export const getBtGroups = params => ajaxGet({url: `linker/bt_groups/`, params}) // 选中payer下的二代PMA/CMA分组及成员link
export const newLinker = params => ajaxPost({url: `linker/`, params})
export const deleterLinker = params => ajaxDelete({url: `linker/`, params})
export const editLinker = params => ajaxPut({url: `linker/`, params})

// 最终用户管理
export const getCustomerList = params => ajaxGet({url: `client/`, params})
// 最终用户新增
export const newCustomer = params => ajaxPost({url: `client/`, params})
// 最终用户删除
export const deleterCustomer = params => ajaxDelete({url: `client/`, params})
// 最终用户修改
export const editCustomer = params => ajaxPut({url: `client/`, params})

// 销售人员管理
export const getSalesList = params => ajaxGet({url: `sales/`, params})
// 销售新增
export const newSales = params => ajaxPost({url: `sales/`, params})
// 销售删除
export const deleterSales = params => ajaxDelete({url: `sales/`, params})
// 销售修改
export const editSales = params => ajaxPut({url: `sales/`, params})
// 销售关系转移
export const transferSales = params => ajaxPost({url: `sales/transfer/`, params})
// 销售转移预览
export const previewTransferSales = params => ajaxGet({url: `sales/preview_transfer/`, params})



// 组织管理
// 获取某个Payer下link账户
export const getAccountList = params => ajaxGet({url: `org/accounts/`, params})
// 获取关联状态
export const getInviteStatus = params => ajaxGet({url: `org/listInviteStatus/`, params})
// 邀请link到payer下,会调用AWS接口
export const inviteAccount = params => ajaxPost({url: `org/inviteAccount/`, params})
// 邀请link到payer下，流程管理
export const inviteAccountLocal = params => ajaxPost({url: `invite/create/`, params})
// 获取销售和伙伴的邀请列表
export const inviteList = params => ajaxGet({url: `invite/list/`, params})
// 删除销售和伙伴的邀请
export const deleteInvite = params => ajaxPost({url: `invite/delete/`, params})
// 管理员同意邀请
export const agreeInvite = params => ajaxPost({url: `invite/accept/`, params})
// 管理员拒绝邀请
export const denyInvite = params => ajaxPost({url: `invite/deny/`, params})

// 解除绑定
export const removeAccountFromOrg = params => ajaxPost({url: `org/removeAccount/`, params})
//关闭账户
export const closeAccountFromOrg = params => ajaxPost({url: `org/closeAccount/`, params})

// Organization related APIs
export const listRoots = params => ajaxGet({url: `org/listRoots/`, params})
export const listOU = params => ajaxGet({url: `org/listOU/`, params})
export const listChildren = params => ajaxGet({url: `org/listChildren/`, params})
export const createOU = params => ajaxPost({url: `org/createOU/`, params})
export const deleteOU = params => ajaxPost({url: `org/deleteOU/`, params})
export const listPolicyForTarget = params => ajaxGet({
    url: `org/listPolicyForTarget/`,
    params: {
        payer_id: params.payer_id,
        target_id: params.target_id
    }
})

export const getAccountStatus = params => ajaxGet({url: `organization/accounts_status/`, params})
export const inviteAccountToOrg = (params, data) => ajaxPost1({
    url: `organization/invite_account/?account_id=` + data.account_id,
    data,
    params
})
export const createAccountToOrg = params => ajaxPost({url: `organization/create_account/`, params})
export const getPoliciesList = params => ajaxGet({url: `organization/list_policies/`, params})
export const getPoliciesListForTarget = params => ajaxGet({url: `organization/list_policies_for_target/`, params})
export const attachPolicy = (params, data) => ajaxPost1({
    url: `organization/attach_policy/?account_id=` + data.account_id,
    params
})
export const detachPolicy = (params, data) => ajaxPost1({
    url: `organization/detach_policy/?account_id=` + data.account_id,
    params
})
export const removeAccount = (params, data) => ajaxPost1({
    url: `organization/remove_account/?account_id=` + data.account_id,
    params
})
export const closeAccountApi = (params, data) => ajaxPost1({
    url: `organization/close_account/?account_id=` + data.account_id,
    params
})
export const sendMailApi = params => ajaxPost({url: `organization/send_notification/`, params})

// AWS Policy related APIs
export const listPolicyAws = params => ajaxGet({url: `org/listPolicy/`, params});
export const attachAwsPolicyWithLink = params => ajaxPost({url: `org/attachPolicy/`, params})
export const detachAwsPolicyWithLink = params => ajaxGet({url: `org/detachPolicy/`, params})

// Local Policy related APIs
export const listPolicy = params => ajaxGet({url: `org/listPolicyLocal/`, params});
export const addPolicy = params => ajaxPost({url: `org/createPolicyLocal/`, params})
export const removePolicy = params => ajaxPost({url: `org/deletePolicyLocal/`, params})
export const listPolicyWithLink = params => ajaxGet({url: `org/listPolicyLocalAttached/`, params});
export const attachPolicyWithLink = params => ajaxPost({url: `org/attachPolicyLocal/`, params})
export const detachPolicyWithLink = params => ajaxPost({url: `org/detachPolicyLocal/`, params})



// 获取超预算和超过告警阈值
export const getBillWarning = params => ajaxGet({url: `bill/monthBillWarning/`, params});






// 获取登录页的信息
export const login = params => ajaxPost({url: `token/`, params})
// 获取验证码
export const getCaptcha = params => ajaxGet({url: `captcha/`, params})
// 获取菜单
export const apiSystemWebRouter = params => ajaxGet({url: `system/menu/web_router/`, params})


// 账单->账单管理
//获取账单列表
export const getBillList = params => ajaxGet({url: `bill/monthBill/`, params})
//下载账单
// 注意：force_regenerate=1 会让后端逐条重生成 Invoice 账单（Excel→LibreOffice→PDF），
// 只对"单 link"下载有意义；批量下载（无 link_id）141 条走一遍必然 nginx/uwsgi 超时，
// 前端只在明确带 link_id 时才自动开重生成；批量走已有文件，用户要重算请显式点"重新生成"。
export const downloadBillByBlob = params => {
    if (params.format) {
        params.file_format = params.format;
        delete params.format;
    }
    if (params.file_format === 'pdf' && params.force_regenerate === undefined && params.link_id) {
        params.force_regenerate = 1;
    }
    return download(`bill/downloadBill/`, params);
}
export const downloadBillByUrl = params => {
    if (params.format) {
        params.file_format = params.format;
        delete params.format;
    }
    if (params.file_format === 'pdf' && params.force_regenerate === undefined && params.link_id) {
        params.force_regenerate = 1;
    }
    return ajaxGet({url:`bill/downloadBill/`, params});
}
// 下载对账单
export const downloadBillDetail = params => ajaxGet({url:`bill/downloadBillDetail/`, params})
// 下载历史账单
export const downloadHistory = params => ajaxGet({url:`bill/downloadHistory/`, params})
// 重新计算账单
export const reGenerateBill = params => ajaxGet({url:`bill/reGenerateBill/`, params})
// 重新下载原始账单
export const reDownloadBill = params => ajaxGet({url:`bill/reDownload/`, params})
// 销售发起确认账单
export const saleConfirmBill = params => ajaxGet({url:`bill/lockBill/`, params})
// 伙伴确认账单
export const agentConfirmBill = params => ajaxGet({url:`bill/checkBill/`, params})
// 创建增值服务
export const getServiceData = params => ajaxGet({url:`bill/serviceBill/`, params})
export const addServiceBill = params => ajaxPost({url:`bill/serviceBill/`, params})
export const delServiceBill = params => ajaxDelete1({url:`bill/serviceBill/`, params})



// 账单->PO管理
// 获取PO列表
export const getPOList = params => ajaxGet({url: `bill/getPO/`, params})
// 下载PO
export const downloadPO = params => ajaxGet({url:`bill/downloadPO/`, params})
export const downloadInvoice = params => ajaxGet({url:`bill/downloadInvoice/`, params})


// 账单 -> 返点报表
export const getRebateList = params => ajaxGet({url: `bill/getDiscount/`, params})// 获取返点报表
// export const downloadRebate = params => ajaxGet({url: `bill/downloadDiscount/`, params})//下载返点报表
export const downloadRebate = params => ajaxGet({url: `bill/downloadDiscount2/`, params})//下载返点报表



// 返点核对
export const getCheckRebateList = params => ajaxGet({url: `billConfig/`, params});//获取返点核对列表
export const updateCheckRebate = params => ajaxPut({url: `billConfig/`, params});//更新返点核对列表





//获取调整返点
export const getRebate = params => ajaxGet({url: `discount/`, params})
//新增调整返点
export const addRebate = params => ajaxPost({url: `discount/`, params})
//修改调整返点
export const adjustRebate = params => ajaxPut({url: `discount/`, params})
//调整返点后重新计算账单金额
export const reCalcBill = params => ajaxGet({url: `bill/reCalcBillSum/`, params})
//调整预算后重新计算
export const setBillBudget = params => ajaxGet({url: `bill/setBillBudget/`, params})
// 调整金额
export const adjustCost = params => ajaxGet({url: `bill/setCost/`, params})

//发送账单
export const sendZhangdan = params => ajaxGet({url: `bill/sendExcelBill/`, params})

//下载link账单汇总表
export const downloadLinkBill = params => ajaxGet({url: `bill/sendLinkExcelBill/`, params})

// 获取登录日志
export const getLoginLogList = (filter, pagination) => {
    const params = {
        ...filter,
        ...pagination
    };
    return ajaxGet({url: `system/login_log/`, params});
};

// system
//user
export const getUserList = params => ajaxGet({url: `system/user/`, params})

//配置邮件模板
export const getEmailTemp = params => ajaxGet({url: `platformsettings/sysconfig/getConfig/`, params})
//配置邮件模板
export const postEmailTemp = params => ajaxPost({url: `platformsettings/sysconfig/setConfig/`, params})
// 获取发送账单记录
export const getLog = params => ajaxGet({url: `bill/maillog/`, params})
// 获取账单详情
export const getBillDetail = params => ajaxGet({url: `bill/bill`, params})
//通過地区，payer和销售查询agent
export const getAgents = params => ajaxGet({url: `agent/search/`, params})


//锁定账单
export const lockBill = params => ajaxGet({url: `bill/lockBill/`, params})
// 更改账单支付状态
export const setBillPaid = params => ajaxGet({url: `bill/setBillPaid/`, params})
// 更改账单支付状态
export const setBillRecv = params => ajaxGet({url: `bill/setBillRecv/`, params})
//获取告警信息
export const getWarningList = params => ajaxGet({url: `bill/monthBillWarning/`, params})

//获取账单下载日志
export const getDownloadLog = params => ajaxGet({url: `bill/downloadlog/`, params})

// 获取账单发票详情
export const getBillInvoice = params => ajaxGet({url: `bill/invoice/details/`, params})

// 获取产品聚合数据（用于饼图）
export const getProductAggregation = params => ajaxGet({url: `bill/productAggregation/`, params})

// 获取BillSum列表（用于实体统计表）
export const getBillSumList = params => ajaxGet({url: `bill/billSumList/`, params})

// 获取资源统计数据（用于详细用量表格）
export const getBillResourceStats = params => ajaxGet({url: `bill/resourceStats/`, params})

// 下载PDF账单
export const downloadPdfBill = params => ajaxGet({
    url: `bill/download-pdf-invoice/`,
    params: {
        ...params,
        force_regenerate: params && params.force_regenerate !== undefined ? params.force_regenerate : 1
    }
})

// 首页统计
// 卡片数据
export const getCardData = params => ajaxGet({url: `bill/dashboard/`, params})
// 根据payer，agent或销售查询linker
export const getLinkers = params => ajaxGet({url: `linker/linkId/`, params})
// 根据linkId获取折线数据
export const getLineData = params => ajaxGet({url: `bill/monthStat/`, params})

/**
 *系统管理
 * */
// 菜单管理列表
export const apiSystemMenu = params => ajaxGet({url: `system/menu/`, params})
// 菜单管理列表 -- 新增菜单
export const apiSystemMenuAdd = params => ajaxPost({url: `system/menu/`, params})
// 菜单管理列表 -- 编辑菜单
export const apiSystemMenuEdit = params => ajaxPut({url: `system/menu/`, params})
// 菜单管理列表 -- 删除菜单
export const apiSystemMenuDelete = params => ajaxDelete({url: `system/menu/`, params})
//获取部门数据,获取菜单树
export const systemMenuTree = params => ajaxGet({url: `system/menu_tree/`, params})
// 菜单管理 》 按钮列表(全部)
export const systemButton = params => ajaxGet({url: `system/button/`, params})
// 菜单管理 》 按钮 编辑
export const systemButtonEdit = params => ajaxPut({url: `system/button/`, params})
// 菜单管理 》 按钮 新增
export const systemButtonAdd = params => ajaxPost({url: `system/button/`, params})
// 菜单管理 》 按钮 删除
export const systemButtonDelete = params => ajaxDelete({url: `system/button/`, params})
// 菜单管理 》 按钮配置列表（针对单个菜单）
export const systemMenuButton = params => ajaxGet({url: `system/menu_button/`, params})
// 菜单管理 》 按钮配置列表（针对单个菜单） 新增
export const systemMenuButtonAdd = params => ajaxPost({url: `system/menu_button/`, params})
// 菜单管理 》 按钮配置列表（针对单个菜单） 编辑
export const systemMenuButtonEdit = params => ajaxPut({url: `system/menu_button/`, params})
// 菜单管理 》 按钮配置列表（针对单个菜单） 删除
export const systemMenuButtonDelete = params => ajaxDelete({url: `system/menu_button/`, params})

// 角色管理列表
export const apiSystemRole = params => ajaxGet({url: `system/role/`, params})
export const apiSystemRole1 = params => ajaxGet({url: `system/roles/`, params})
// 角色管理列表-修改
export const apiSystemRoleEdit = params => ajaxPut({url: `system/role/`, params})
// 角色管理列表 -- 新增角色
export const apiSystemRoleAdd = params => ajaxPost({url: `system/role/`, params})
// 角色管理列表 -- 新增角色
export const apiSystemRoleDelete = params => ajaxDelete({url: `system/role/`, params})
//通过角色id,获取菜单数据
export const apiSystemRoleIdToMenu = params => ajaxGet({url: `system/role_id_to_menu/`, params})
export const apiSystemRoleIdToMenuid = (id) => ajaxGet({url: `system/role_id_to_menu/` + id + '/'})

//权限管理
// 权限管理 -- 保存
export const apiPermissionSave = params => ajaxPut({url: `system/permission/`, params})

//登录用户管理
export const apiSystemUser = params => ajaxGet({url: `system/user/`, params})
//登录用户管理-新增
export const apiSystemUserAdd = params => ajaxPost({url: `system/user/`, params})
//登录用户管理-修改
export const apiSystemUserEdit = params => ajaxPut({url: `system/user/`, params})
//登录用户管理-删除
export const apiSystemUserDelte = params => ajaxDelete({url: `system/user/`, params})

// 伙伴子账号管理
export const apiPartnerSubAccount = params => ajaxGet({url: `system/partner/subaccount/`, params})
export const apiPartnerSubAccountAdd = params => ajaxPost({url: `system/partner/subaccount/`, params})
export const apiPartnerSubAccountEdit = params => ajaxPut({url: `system/partner/subaccount/`, params})
export const apiPartnerSubAccountDelete = params => ajaxDelete({url: `system/partner/subaccount/`, params})
// 获取可分配的Payer列表
export const getAvailablePayers = params => ajaxGet({url: `system/partner/subaccount/available_payers/`, params})
// 获取可分配的Link列表
export const getAvailableLinks = params => ajaxGet({url: `system/partner/subaccount/available_links/`, params})

/**
 *个人中心
 * */
// 获取当前个人用户信息
export const systemUserUserInfo = params => ajaxGet({url: `system/user/user_info/`, params})
// 更新修改当前个人用户信息
export const systemUserUserInfoEdit = params => ajaxPut({url: `system/user/user_info/`, params})
// 用户重置个人密码
export const systemUserChangePassword = params => ajaxPut({url: `system/user/change_password/`, params})


/**
 *系统配置
 * */

// 系统配置
export const platformsettingsSysconfig = params => ajaxGet({url: `platformsettings/sysconfig/`, params})
// 系统配置 -- 新增
export const platformsettingsSysconfigAdd = params => ajaxPost({url: `platformsettings/sysconfig/`, params})
// 系统配置 -- 编辑
export const platformsettingsSysconfigEdit = params => ajaxPut({url: `platformsettings/sysconfig/`, params})
// 系统配置 -- 删除
export const platformsettingsSysconfigDelete = params => ajaxDelete({url: `platformsettings/sysconfig/`, params})
// 系统配置 -- 保存子项
export const platformsettingsSysconfigSavecontent = params => ajaxPut({
    url: `platformsettings/sysconfig/save_content/`,
    params
})

/**
 *计划任务
 * */

// 计划任务
export const crontabPeriodictask = params => ajaxGet({url: `crontab/periodictask/`, params})
// 计划任务 -- 新增
export const crontabPeriodictaskAdd = params => ajaxPost({url: `crontab/periodictask/`, params})
// 计划任务 -- 编辑
export const crontabPeriodictaskEdit = params => ajaxPut({url: `crontab/periodictask/`, params})
// 计划任务 -- 删除
export const crontabPeriodictaskDelete = params => ajaxDelete({url: `crontab/periodictask/`, params})
// 计划任务 -- 开始/暂停
export const crontabPeriodictaskEnabled = params => ajaxPut({url: `crontab/periodictask/enabled/`, params})
// 计划任务 获取本地所有tasks文件中的task任务方法
export const crontabPeriodictaskMethodlist = params => ajaxGet({url: `crontab/periodictask/tasklist/`, params})

// 计划任务 获取任务执行结果
export const crontabTaskresult = params => ajaxGet({url: `crontab/taskresult/`, params})

// 平台设置 图片上传
export const platformsettingsUploadPlatformImg = params => uploadImg({
    url: `platformsettings/uploadplatformimg/`,
    params
})

export const getBill = params => { return service.get(`${base}/bill/bill`, { params: params }); };
export const getBillSum = params => { return service.get(`${base}/bill/billSum`, { params: params }); };
export const exportBill = params => { return service.get(`${base}/bill/exportBill`, { params: params }); };
export const exportBillSum = params => { return service.get(`${base}/bill/exportBillSum`, { params: params }); };

// DataSync API
export const getDataSyncLocations = params => ajaxGet({url: `datasync/locations/`, params})
export const createDataSyncLocation = params => ajaxPost({url: `datasync/locations/create/`, params})
export const getDataSyncTasks = params => ajaxGet({url: `datasync/tasks/`, params})
export const createDataSyncTask = params => ajaxPost({url: `datasync/tasks/create/`, params})
export const getDataSyncExecutions = params => ajaxGet({url: `datasync/executions/`, params})
export const executeDataSyncTask = params => ajaxPost({url: `datasync/tasks/start/`, params})
export const syncDataSyncFromAws = params => ajaxPost({url: `datasync/sync-from-aws/`, params})
export const syncExecutionStatus = params => ajaxPost({url: `datasync/executions/sync-status/`, params})
export const syncAllRunningExecutions = params => ajaxPost({url: `datasync/executions/sync-all-running/`, params})

// 更新DataSync位置别名
export const updateDataSyncLocationAlias = params => ajaxPost({url: `datasync/locations/update-alias/`, params})

// DataSync Agent管理
export const listDataSyncAgents = (params) => ajaxGet({
    url: 'datasync/agents/list/',
    params
})

export const syncDataSyncAgents = (params) => ajaxPost({
    url: 'datasync/agents/sync/',
    params
})



export const updateAgentStatus = (params) => ajaxPost({
    url: 'datasync/agents/update_status/',
    params
})

// 获取代理绑定的位置
export const getAgentLocations = (params) => ajaxGet({
    url: 'datasync/agents/locations/',
    params
})

// 获取位置绑定的代理
export const getLocationAgents = (params) => ajaxGet({
    url: 'datasync/locations/agents/',
    params
})

// 同步代理位置绑定信息
export const syncAgentLocations = (params) => ajaxPost({
    url: 'datasync/agents/sync_locations/',
    params
})
